import { AbsoluteFill, Img, spring, staticFile, useCurrentFrame, useVideoConfig } from "remotion";
import { preloadImage } from "@remotion/preload";
import './assets/css/Especs.css'
import { useEffect } from "react";

interface SeccionInterface {
	title: string,
	text: string
}

export const EspecificacionSeguridadSection = ({ title, text }: SeccionInterface) => {
	const frame = useCurrentFrame();
	const { durationInFrames, fps } = useVideoConfig();
	useEffect(() => {
		preloadImage(staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/01_FONDO.jpg"));
		preloadImage(staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/claro-white.svg"));
	}, []);

	const scaleSection = spring({
		fps,
		frame,
		config: { damping: 400, stiffness: 400 },
		from: 1,
		to: 2,
		delay: (durationInFrames - 8)
	});
	const blurSection = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 10,
		delay: (durationInFrames - 8)
	});

	// ? TITLE
	const titleTranslate = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 10
	});
	const titleOpacity = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 10
	});
	const titleLineWidth = spring({
		fps,
		frame,
		config: { damping: 10, stiffness: 10 },
		from: 0,
		to: 56,
		delay: 10
	});

	// ? DESCRIPCION
	const descripcionTranslate = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 20
	});
	const descripcionOpacity = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 20
	});

	// ? PHONE

	const opacityPhone = spring({
		fps,
		frame: frame * 5,
		config: { damping: 100, stiffness: 100 },
		from: 0,
		to: 1,
		delay: 0
	});
	const scalePhone = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: .5,
		to: 1,
		delay: 0
	});
	const rotatePhone = spring({
		fps,
		frame,
		config: { damping: 100, stiffness: 100 },
		from: -30,
		to: 0,
		delay: 0
	});
	return (
		<AbsoluteFill style={{
			filter: (blurSection > 0) ? `blur(${blurSection}px)` : '',
			transform: `scale(${scaleSection})`
		}}>
			<AbsoluteFill style={{
				backgroundColor: "#B21F1D"
			}}>
				<Img className="fondo" src={staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/07_FONDO.jpg")} style={{
					position: "absolute"
				}} />
			</AbsoluteFill>
			<AbsoluteFill>
				<div className="phone" style={{
					position: "absolute",
					bottom: -145,
					left: 180,
					opacity: opacityPhone,
					transformOrigin: "bottom",
					transform: `scale(${scalePhone}) rotate(${rotatePhone}deg)`
				}}>
					<Img className="fondo" src={staticFile(process.env.REACT_APP_URL_PUBLIC_VIDEO + "/Videos/CLARO_01/07_PHONE-2.png")} style={{
						width: "100%",
						maxWidth: 800,
					}} />
				</div>
				<div className="especificaciones seguridad" style={{
					position: "absolute",
					top: 230,
					right: 180,
					minWidth: 710,
					maxWidth: 710
				}}>
					<div className="title">
						<h1 style={{
							position: "relative",
							margin: 0,
							fontSize: 55,
							color: "#fff",
							fontWeight: "bold",
							paddingBottom: 30,
							marginBottom: 40,
							opacity: titleOpacity,
							transform: `translateY(${titleTranslate}px)`
						}}>{title}</h1>
						<div className="line" style={{
							width: `${titleLineWidth}%`
						}}></div>
					</div>
					<p style={{
						margin: 0,
						fontSize: 40,
						color: "#fff",
						fontWeight: "300",
						textAlign: "left",
						maxWidth: 690,
						opacity: descripcionOpacity,
						transform: `translateY(${descripcionTranslate}px)`
					}}>{text}</p>
				</div>
			</AbsoluteFill>
		</AbsoluteFill>
	);
};